import { cn } from '@/lib/utils'

export function HighlightText({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <span
      className={cn(
        'bg-app-highlight box-decoration-clone rounded-xl px-2 text-primary',
        className,
      )}
    >
      {children}
    </span>
  )
}
